// TennisTrack Hub — App Router | 029 Project
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pagina pubblica
import LandingPage from './pages/Landing/LandingPage';

// Pagine Auth
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import RecuperaPassword from './pages/Auth/RecuperaPassword';

// Pagine App
import Dashboard from './pages/Dashboard/Dashboard';
import ListaAtleti from './pages/Atleti/ListaAtleti';
import FormAtleta from './pages/Atleti/FormAtleta';
import ProfiloAtleta from './pages/Atleti/ProfiloAtleta';
import FormAllenamento from './pages/Allenamenti/FormAllenamento';
import DettaglioAllenamento from './pages/Allenamenti/DettaglioAllenamento';

// Pagine Template
import LibreriaTemplate from './pages/Template/LibreriaTemplate';
import FormTemplate from './pages/Template/FormTemplate';
import DettaglioTemplate from './pages/Template/DettaglioTemplate';
import DettaglioMioTemplate from './pages/Template/DettaglioMioTemplate';

// Pagine Pro
import PaginaPro from './pages/Pro/PaginaPro';

// Pagine Profilo & Admin
import ProfiloUtente from './pages/Profilo/ProfiloUtente';
import PannelloAdmin from './pages/Admin/PannelloAdmin';

// Pagine Medical Network
import RicercaMedici from './pages/Medici/RicercaMedici';
import SchedaMedico  from './pages/Medici/SchedaMedico';

// Route protetta — solo utenti loggati
const PrivateRoute = ({ children }) => {
  const { utente, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#a0a0b0' }}>Caricamento...</div>;
  return utente ? children : <Navigate to="/login" replace />;
};

// Route pubblica — reindirizza al dashboard se già loggato
const PublicRoute = ({ children }) => {
  const { utente, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#a0a0b0' }}>Caricamento...</div>;
  return !utente ? children : <Navigate to="/dashboard" replace />;
};

// Landing pubblica — se loggato va al dashboard, altrimenti mostra la landing
const LandingPublicRoute = ({ children }) => {
  const { utente, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#a0a0b0' }}>Caricamento...</div>;
  return !utente ? children : <Navigate to="/dashboard" replace />;
};

const AppRoutes = () => (
  <Routes>
    {/* Landing pubblica */}
    <Route path="/"                  element={<LandingPublicRoute><LandingPage /></LandingPublicRoute>} />

    {/* Route pubbliche Auth */}
    <Route path="/login"             element={<PublicRoute><Login /></PublicRoute>} />
    <Route path="/register"          element={<PublicRoute><Register /></PublicRoute>} />
    <Route path="/recupera-password" element={<PublicRoute><RecuperaPassword /></PublicRoute>} />

    {/* Route protette */}
    <Route path="/dashboard"         element={<PrivateRoute><Dashboard /></PrivateRoute>} />
    <Route path="/atleti"            element={<PrivateRoute><ListaAtleti /></PrivateRoute>} />
    <Route path="/atleti/nuovo"      element={<PrivateRoute><FormAtleta /></PrivateRoute>} />
    <Route path="/atleti/:id"        element={<PrivateRoute><ProfiloAtleta /></PrivateRoute>} />
    <Route path="/atleti/:id/modifica"      element={<PrivateRoute><FormAtleta /></PrivateRoute>} />
    <Route path="/allenamenti/nuovo/:atletaId" element={<PrivateRoute><FormAllenamento /></PrivateRoute>} />
    <Route path="/allenamenti/:id"          element={<PrivateRoute><DettaglioAllenamento /></PrivateRoute>} />

    {/* Route Template */}
    <Route path="/template"                        element={<PrivateRoute><LibreriaTemplate /></PrivateRoute>} />
    <Route path="/template/nuovo"                  element={<PrivateRoute><FormTemplate /></PrivateRoute>} />
    <Route path="/template/miei/:id"               element={<PrivateRoute><DettaglioMioTemplate /></PrivateRoute>} />
    <Route path="/template/miei/:id/modifica"      element={<PrivateRoute><FormTemplate /></PrivateRoute>} />
    <Route path="/template/server/:id"             element={<PrivateRoute><DettaglioTemplate /></PrivateRoute>} />

    {/* Route Pro */}
    <Route path="/premium"          element={<PrivateRoute><PaginaPro /></PrivateRoute>} />
    <Route path="/premium/successo" element={<PrivateRoute><PaginaPro /></PrivateRoute>} />

    {/* Route Profilo & Admin */}
    <Route path="/profilo"  element={<PrivateRoute><ProfiloUtente /></PrivateRoute>} />
    <Route path="/admin"    element={<PrivateRoute><PannelloAdmin /></PrivateRoute>} />

    {/* Route Medical Network */}
    <Route path="/medici"     element={<PrivateRoute><RicercaMedici /></PrivateRoute>} />
    <Route path="/medici/:id" element={<PrivateRoute><SchedaMedico  /></PrivateRoute>} />

    {/* Default — 404 → home/dashboard */}
    <Route path="*"  element={<Navigate to="/" replace />} />
  </Routes>
);

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  </BrowserRouter>
);

export default App;
